import React, { useEffect, useRef, useState } from "react";
import WorkbenchProvider, { useWorkbenchContext } from "../../context/WorkbenchContext";
import ReactFlow, { ReactFlowProvider } from "reactflow";
import { useExportEmbeddedModelResultMutation, useGenerateSemanticQueriesMutation } from "../../service/apiSlices/sematicModel";
import CustomReactFlowWrapper from "../../components/FlowBoard/ReactFlowWrapper";
import PinboardTopbar from "./PinboardTopbar";
import BottomTableBar from "../../components/Querbuilder/bottomBar";
import { useDispatch } from "react-redux";
import { setShowConnectionExpiredModal } from "../../service/apiSlices/staticApi";
import { showErrorToast, showSuccessToast } from "../../utilities/toastUtils";
import { downloadFileFromUrl } from "../../utilities/utils";
import CustomReactFlow from "../../components/FlowBoard/CustomReactflow";
import Loader from "../../components/Loader/Loader";

const Pinboard = () => {
  const { workBenchData } = useWorkbenchContext();
  const dispatch = useDispatch();

  // const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setRowPerPage] = useState(100);
  const [queryResponse, setQueryResponse] = useState({ data: [], total: 0 })

  const containerRef = useRef<any>(null);

  const [triggerQueryTableResult, { isLoading }] = useGenerateSemanticQueriesMutation();
  const [exportEmbeddedModelResult] = useExportEmbeddedModelResultMutation();

  const { data: result, total } = queryResponse || {};

  useEffect(() => {
    if (!(workBenchData?.connection_key && workBenchData?.mapping_link_id))
      return;
    fetchQueryTableResult();
  }, [workBenchData, triggerQueryTableResult, page, perPage]);

  const fetchQueryTableResult = () => {
    // setLoading(true);
    try {
      const payload = {
        connection_key: workBenchData.connection_key,
        mapping_link_id: workBenchData.mapping_link_id,
      };
      const params = {
        page,
        limit: perPage,
      }
      triggerQueryTableResult({ payload, params })
        .unwrap()
        .then((res) => {
          // setLoading(false)
          if (res.status_code === 400) {
            dispatch(setShowConnectionExpiredModal())
            return;
          }
          setQueryResponse(res)
        });
    } catch (error) {
      // setLoading(false)
      console.error(error);
    }
  };

  const handleOnExcelExport = async () => {
    const payload = {
      connection_key: workBenchData.connection_key,
      mapping_link_id: workBenchData.mapping_link_id,
    };
    const params = {};
    const res = await exportEmbeddedModelResult({ payload, params }).unwrap();
    if (res.data === true) {
      showSuccessToast(res.message);
      return
    };
    if (Array.isArray(res.data) && res.data.length < 1) {
      showErrorToast(res.message);
      return;
    }

    downloadFileFromUrl(res?.data);
    showSuccessToast(res.message);
  }

  return (
    <WorkbenchProvider>
      <ReactFlowProvider>
        {isLoading && <Loader loading={isLoading} />}
        <CustomReactFlow
          containerRef={containerRef}
          defaultViewport={{ x: 0, y: 0, zoom: 1 }}
          minZoom={0.5}
          maxZoom={2}
          panOnScroll
          selectionOnDrag
          nodesDraggable={false}
        >
          <PinboardTopbar queryResult={queryResponse} />
          <BottomTableBar
            page={page}
            setPage={setPage}
            setRowPerPage={setRowPerPage}
            perPage={perPage}
            getQueryTableResult={{ result: result || [], total: total }}
            config={{ showCreateReport: false, isExpanded: false }}
            loading={isLoading}
            onExcelExport={handleOnExcelExport}
          />
        </CustomReactFlow>
      </ReactFlowProvider>
    </WorkbenchProvider>
  );
};

export default Pinboard;

